export default __webpack_public_path__ + "static/media/stacks.2f48567a.png";